import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common';

const states: Ng1StateDeclaration[] = [
    {
        name: 'trends',
        url: '/trends/',
        component: 'wtTrendsState',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.master, Roles.engineer, Roles.reader])
        },
        data: {
            visible: true,
            sortingOrder: 4,
            isAuthenticated: true,
            isConnected: true,
            icon: 'fa-line-chart',
            displayName: 'Trends',
            editRoles: [Roles.master, Roles.engineer],
            editButtonVisibility: () => false,
            subMenu: {
                subState: 'trend'
            },
            subStates: ['trend', 'tables']
        }
    }, {
        name: 'trend',
        url: '/trend/:beginDate/:endDate/:trendGuid/:maximized',
        component: 'wtTrendsState',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.master, Roles.engineer, Roles.reader])
        },
        params: {
            beginDate: '',
            endDate: '',
            trendGuid: '',
            maximized: ''
        },
        data: {
            //visible: true,
            //sortingOrder: 3,
            isAuthenticated: true,
            isConnected: true,
            icon: 'fa-line-chart',
            displayName: 'Trend',
            editRoles: [Roles.master, Roles.engineer],
            editButtonVisibility: () => false,

        }
    },
    {
        name: 'tables',
        url: '/tables',
        component: 'wtDynamicTable',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.master, Roles.engineer, Roles.reader])
        },
        data: {
            visible: false,
            sortingOrder: 100,
            isAuthenticated: true,
            isConnected: true,
            icon: 'fa-table',
            displayName: 'Table',
            editRoles: [Roles.master, Roles.engineer],
            editButtonVisibility: () => false,
        }
    }];

export default states;